import { EmailNotification, EmailNotificationAction } from './emailNotificationTypes';

export const updateEmailNotificationStateReducer = (
  state: EmailNotification,
  action: EmailNotificationAction,
) => ({
  ...state,
  isSidebarOpen: action?.payload?.isSidebarOpen,
});
